import api from "./axiosInstance";
export const listConversations=()=>api.get("/conversations").then(r=>r.data.conversations);
export const createConversation=user_id=>api.post("/conversations",{user_id}).then(r=>r.data.conversation);
export const listMessages=id=>api.get(`/conversations/${id}/messages`).then(r=>r.data.messages);
export const sendMessage=(id,content)=>api.post(`/conversations/${id}/messages`,{content}).then(r=>r.data.message);
export const markConversationRead=(id,last_message_id)=>api.patch(`/conversations/${id}/read`,{last_message_id});
